import React from "react";

import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  switchButtons: {
    display: "flex",
    alignItems: "center",
    justifySelf: "flex-end",
    borderRadius: "16px",
    padding: "2px",
    gap: "10px",
    backgroundColor: theme.palette.background.default,
  },
  links: {
    borderRadius: "14px",
    fontSize: "1rem",
    fontWeight: "500",
    padding: "10px 15px",
    display: "flex",
    alignItems: "center",
    minWidth: "max-content",
    cursor: "pointer",
    color: `${theme.palette.text.primary} !important`,
    "&.active": {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

export default function SwitchButton({ deploy, setDeploy }) {
  const classes = useStyles();

  return (
    <div className={`switch-buttons ${classes.switchButtons}`}>
      <span
        onClick={() => setDeploy(true)}
        className={`${deploy ? "active" : ""} ${classes.links}`}
      >
        Deploy Liquidity
      </span>
      <span
        onClick={() => setDeploy(false)}
        className={`${!deploy ? "active" : ""} ${classes.links}`}
      >
        Remove Liquidity
      </span>
    </div>
  );
}
